import Logo from "./Logo";
import { Logo as HCgovLogo } from "../Logo";
import { getLanguage } from '@cmsgov/design-system';
import { t } from "../i18n";
import { jsx as _jsx, jsxs as _jsxs } from "preact/compat/jsx-runtime";
const LogosRow = function (props) {
  return /*#__PURE__*/_jsx("div", {
    className: "ds-l-container",
    children: /*#__PURE__*/_jsxs("div", {
      className: "hc-c-footer__logo-row",
      children: [/*#__PURE__*/_jsx(Logo, {
        href: getLanguage() === 'es' ? 'https://www.cuidadodesalud.gov' : 'https://www.healthcare.gov',
        children: /*#__PURE__*/_jsx(HCgovLogo, {
          titleId: "hc-c-footer__logo-title",
          className: props.logoClassName ?? ''
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "hc-c-footer__disclaimer",
        children: [getLanguage() === 'en' && /*#__PURE__*/_jsxs("p", {
          children: ["Health Insurance Marketplace", /*#__PURE__*/_jsx("sup", {
            children: "\xAE"
          }), " is a registered trademark of the Department of Health & Human Services."]
        }), /*#__PURE__*/_jsx("p", {
          dangerouslySetInnerHTML: {
            __html: t('footer.disclaimer')
          }
        })]
      })]
    })
  });
};
export default LogosRow;